// @flow
import React from 'react';

import type { TackleReel } from '../../models/tackle_reels/TackleReel';
import { TACKLE_REEL_COLUMN_DEFINITIONS } from '../../models/tackle_reels/TackleReel';

type Props = {
  tackleReels: Array<TackleReel>,
  displayColumns: Array<string>,
};

type Columns = {
  key: string,
  label: string,
};

function ReelTableRoot(props: Props): React$Node {
  // ReactOnRailsの不具合で直接Hooksを使ってるコンポーネントをexportできない
  return <ReelTable {...props} />;
}

function ReelTable({ tackleReels, displayColumns }: Props) {
  const columns: Array<Columns> = TACKLE_REEL_COLUMN_DEFINITIONS.reduce(
    (acc, d) => {
      if (displayColumns.includes(d.key)) acc.push(d);
      return acc;
    },
    []
  );

  return (
    <>
      <div data-scope-path="tacklebox/series/models_table">
        <table>
          <thead>
            <tr className="">
              {columns.map(c => {
                return <th key={c.key}>{c.label}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {tackleReels.map(r => {
              return (
                <tr key={r.id}>
                  {columns.map(c => {
                    if (c.key === 'name_en') {
                      return (
                        <td key={c.key}>
                          <a href={`/reels/${r.id}`}>{r[c.key]}</a>
                        </td>
                      );
                    } else if (c.key === 'lowest_price') {
                      let lowestPriceCell = null;
                      if (r[c.key]) {
                        lowestPriceCell = r[c.key].toLocaleString() + '円';
                      }
                      if (
                        r['sell_at_base'] &&
                        r['base_product_id'] &&
                        lowestPriceCell
                      ) {
                        return (
                          <td key={c.key}>
                            <a
                              href={`https://anglers.thebase.in/items/${r.base_product_id}`}
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              {lowestPriceCell}
                            </a>
                          </td>
                        );
                      } else if (lowestPriceCell) {
                        return (
                          <td key={c.key}>
                            <a href={`/reels/${r.id}`}>{lowestPriceCell}</a>
                          </td>
                        );
                      } else {
                        return <td key={c.key}>-</td>;
                      }
                    } else {
                      return <td key={c.key}>{r[c.key]}</td>;
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ReelTableRoot;
